import {Inject, Optional, Pipe, PipeTransform} from '@angular/core';
import {UmpireImage} from '@tisa-group/models';
import {ImageVariantPipe} from '@tisa-group/core/pipes/image-variant';
import {TISA_CLOUDFRONT_ID} from '@tisa-group/core/providers';
import {CLOUDFRONT_ID_REQUIRED} from './simple-image-variant.errors';

@Pipe({
  name: 'simpleImageVariant',
  standalone: false,
})
export class SimpleImageVariantPipe implements PipeTransform {
  constructor(
    @Optional() @Inject(TISA_CLOUDFRONT_ID) readonly tisaCloudFrontId: string | undefined,
  ) {
    if (!tisaCloudFrontId) {
      throw CLOUDFRONT_ID_REQUIRED;
    }
  }

  transform(
    value: Partial<UmpireImage> | undefined,
    width: number,
    height: number,
    quality?: number,
  ): string {
    if (!value) {
      return '';
    }
    const path = value.path ?? value.id;
    let url = '';

    if (width >= 0 && height >= 0) {
      url += `fit-in/${width}x${height}`;
    }
    url += ImageVariantPipe.getFiltersString({quality}, true);
    url += '/filters:format(.webp)';

    return `https://${this.tisaCloudFrontId}.cloudfront.net/${url}/${path}`;
  }
}
